import React from 'react';
import { render } from 'react-dom';
import SignIn from '@updater-core/view/components/SignIn';

export const createView = ({ container }) => {
  return {
    render: (props) =>
      render(
        <div className="uds-page-cx-1 uds-mt-8">
          <SignIn {...props} />
        </div>,
        container
      ),
    destroy: () => render(null, container),
  };
};
